import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AbstractFieldWriteComponent } from '../base-field/abstract-field-write.component';

@Component({
  selector: 'ccd-write-text-field',
  template: require('./write-text-field.html')
})
export class WriteTextFieldComponent extends AbstractFieldWriteComponent implements OnInit {

  textControl: FormControl;

  ngOnInit() {
    this.textControl = this.registerControl(new FormControl(this.caseField.value));
  }
}
